import { CustomInputMappingField } from "../../..";

export const compareFields = (fieldA: CustomInputMappingField, fieldB: CustomInputMappingField): number => {

    if (fieldA.fieldOrder && fieldB.fieldOrder) {
        if (fieldA.fieldOrder < fieldB.fieldOrder) {
            return -1;
        }
        if (fieldA.fieldOrder > fieldB.fieldOrder) {
            return 1;
        }
    }
    return 0;
}
